var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item){return _c('ul',{key:item.id},[_vm._t("items",null,{"item":item})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }